<template>
  <div>
    <page-title>IMDG Guide and Shippers Manual</page-title>
  </div>
</template>

<script>
export default {
  name: "ImdgGuide",
};
</script>
